export const SET_ACTION_MENU_ANCHOR_EL = "SET_ACTION_MENU_ANCHOR_EL";
export const SET_ACTION_MENU_PLACEMENT = "SET_ACTION_MENU_PLACEMENT";
export const SET_ACTION_MENU_OPEN = "SET_ACTION_MENU_OPEN";
export const SET_ACTION_MENU_ID = "SET_ACTION_MENU_ID";

